import { http, HttpResponse } from 'msw'

export const mockDeactivateCustomerCard = http.put(
  '/my-business/api/agency/v1/customers/:customerId/cards/:cardId/deactivate',
  () =>
    HttpResponse.json({ timestamp: new Date().toISOString() }, { status: 200 }),
)
